import Popup from '../../components/base/Popup';

export default () => {
    const popupQuickView = new Popup($('#popup-quick-view-checkout'));
    popupQuickView.init();

    if (window.location.pathname.indexOf('/html/') === 0) {
        // eslint-disable-next-line no-unused-expressions,import/extensions
        import('./quickViewFrontend.js');
    } else {
        // eslint-disable-next-line no-unused-expressions,import/extensions
        import('./quickViewBackend.js');
    }
};
